import type { ShopifyAssetResponse } from '~/modules/shopify/types';
import type { UseQueryOptions } from '@tanstack/react-query';

import { useQuery } from '@tanstack/react-query';
import { fetchFromAPI } from '~/api/utils';

const queryKey = 'shopifyAssets';
export type ShopifyAssetsQueryVariables = undefined;
export const useQueryShopifyAssets = <TError = Error, TData = ShopifyAssetResponse>(
  variables?: ShopifyAssetsQueryVariables,
  options?: UseQueryOptions<ShopifyAssetResponse, TError, TData>,
) => {
  return useQuery<ShopifyAssetResponse, TError, TData>({
    queryKey: [queryKey, variables],
    queryFn: () => fetchFromAPI('/api/shopify/assets', { method: 'GET' }),
    ...options,
  });
};
useQueryShopifyAssets.getKey = (variables: ShopifyAssetsQueryVariables) => [queryKey, variables];
